<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

<div class="spinner" *ngIf="loading"><mat-progress-spinner mode="indeterminate"></mat-progress-spinner></div>

<ng-container *ngIf="iAmDealer && !watchlist">
	<div class="user_banner" *ngIf="!loading">
		<img [src]="dealerInfo['dealer']['coverImage']" />
		<!--Top Banner-->

		<div class="profile_content">
			<table width="100%" border="0" cellspacing="0" cellpadding="0">
				<tr>
					<td rowspan="5" class="user_img_col">
						<div class="user_img"><img [src]="dealerInfo['dealer']['profileImage']" /></div>
					</td>

					<td class="user_img_col_2">&nbsp;</td>

					<td>&nbsp;</td>
				</tr>

				<tr>
					<td>
						<span class="dealer_title">
							<mat-icon class="mat-icon-rtl-mirror">business</mat-icon>
							{{ dealerInfo['dealer']['companyName'] }}
						</span>
					</td>
				</tr>

				<tr>
					<td>
						<mat-icon class="mat-icon-rtl-mirror">call</mat-icon>
						{{ dealerInfo['dealer']['phonePrefix'] }} {{ dealerInfo['dealer']['phone'] }}
					</td>
				</tr>

				<tr>
					<td class="location">
						<mat-icon>location_on</mat-icon>
						{{ dealerInfo['dealer']['address'] }}
					</td>
				</tr>

				<tr *ngIf="dealerInfo['dealer']['id'] === user['userID']">
					<td class="money">
						<mat-icon>account_balance_wallet</mat-icon>
						{{ dealerInfo['dealer']['credit']['currentCredit'] }} {{ dealerInfo['dealer']['credit']['currency'] }}
					</td>
				</tr>
			</table>
		</div>
	</div>

	<mat-divider *ngIf="!loading"></mat-divider>
</ng-container>
<div class="mdc-layout-grid__inner" *ngIf="!loading">
	<div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone row" *ngIf="isMe">
		<div class="col-auto fs-24px fw-500">{{ watchlist ? locale.translations['header']['n8'] : locale.translations['app-update']['n328']['n328-2'] }}</div>
		<div class="col" [ngStyle]="{ 'text-align': 'end' }" *ngIf="!watchlist">
			<button [matMenuTriggerFor]="adsFilter" mat-stroked-button mat-button color="primary" class="text-center fw-400 fs-14px v2">
				<mat-icon class="mat-icon-rtl-mirror fs-18px">list</mat-icon>
				<span>{{ adFilterText | titlecase }}</span>
				<span class="missed-call-bg">{{ totalAdsLength }}</span>
			</button>
		</div>
	</div>

	<!-- no ads -->
	<ng-container *ngIf="ads && ads.length === 0">
		<div class="mdc-layout-grid__cell--span-12">
			<!-- me -->
			<ng-container *ngIf="isMe">
				<div class="mdc-layout-grid__inner center">
					<div class="mdc-layout-grid__cell--span-12">
						<mat-icon class="large">sentiment_very_dissatisfied</mat-icon>
					</div>

					<div class="mdc-layout-grid__cell--span-12">
						<h4 id="n80" class="n106">
							{{ watchlist ? locale.translations['user']['user-ads']['n106'] : locale.translations['user']['user-ads']['n80'] }}
						</h4>
					</div>

					<div class="mdc-layout-grid__cell--span-12 n18" id="n81">
						<a mat-flat-button color="primary" [routerLink]="watchlist ? ['/'] : ['/placead']">
							{{ watchlist ? locale.translations['404']['n18'] : locale.translations['user']['user-ads']['n81'] }}
						</a>
					</div>
				</div>
			</ng-container>

			<!-- not me -->
			<ng-container *ngIf="!isMe">
				<div class="mdc-layout-grid__inner center">
					<div class="mdc-layout-grid__cell--span-12">
						<mat-icon class="large">face</mat-icon>
					</div>

					<div class="mdc-layout-grid__cell--span-12" id="n82">
						<h4>{{ locale.translations['user']['user-ads']['n82'] }}</h4>
					</div>

					<div class="mdc-layout-grid__cell--span-12 n18">
						<a mat-flat-button color="primary" href="/">
							{{ locale.translations['404']['n18'] }}
						</a>
					</div>
				</div>
			</ng-container>
		</div>
	</ng-container>

	<!-- ads -->
	<ng-container *ngIf="ads && ads.length > 0">
		<div
			class="mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone ad"
			*ngFor="let ad of ads; let i = index"
		>
			<a [routerLink]="['/ad/' + ad['id']]">
				<div class="paid n41 n118" *ngIf="ad['vipPlus'] === '1' || ad['vip'] === '1'">
					<div class="stripe" [ngClass]="{ vipPlus: ad['vipPlus'] === '1', vip: ad['vip'] === '1' }"></div>

					<div
						[attr.dir]="ad.vipPlus === '1' ? 'ltr' : null"
						class="label"
						[ngClass]="{
							vipPlus: ad['vipPlus'] === '1',
							vip: ad['vip'] === '1',
							'border-radius-bottom-right': locale.lang === 'en',
							'border-radius-bottom-left': locale.lang !== 'en'
						}"
					>
						{{ ad['vip'] === '1' ? locale.translations['ads']['ad']['n118'] : locale.translations['n729'] }}
					</div>
				</div>
			</a>
			<!--
			<a [routerLink]="['/ad/' + ad['id']]">
				<div class="paid n41 n118" *ngIf="ad['premium'] === '1' || ad['vip'] === '1'">
					<div class="stripe" [ngClass]="{ premium: ad['vip'] === '0', vip: ad['vip'] === '1' }"></div>

					<div
						class="label"
						[ngClass]="{
							premium: ad['vip'] === '0',
							vip: ad['vip'] === '1',
							'border-radius-bottom-right': locale.lang === 'en',
							'border-radius-bottom-left': locale.lang !== 'en'
						}"
					>
						{{ ad['vip'] === '1' ? locale.translations['ads']['ad']['n118'] : locale.translations['ads']['ad']['n41'] }}
					</div>
				</div>
			</a> -->

			<a class="sold" [routerLink]="['/ad/' + ad['id']]" (click)="onAdClick()" *ngIf="ad['sold'] === '1'">
				<span class="label">
					{{ locale.translations['ads']['ad']['n111'] }}
				</span>
			</a>

			<a class="payment-status" [routerLink]="['/ad/' + ad['id']]" (click)="onAdClick()" *ngIf="ad['paymentStatus'] === '0'">
				<span class="label premium" *ngIf="ad['paymentPackage'] === '1' && ad['premium'] !== '1'">
					{{ locale.translations['ads']['ad']['n224'] }}
				</span>

				<span
					class="label vip"
					*ngIf="
						(ad['paymentPackage'] === '2' && ad['paymentStatus'] === '0') ||
						(ad['paymentPackage'] === '0' && ad['premium'] === '1' && ad['vip'] === '0')
					"
				>
					{{ locale.translations['ads']['ad']['n225'] }}
				</span>

				<span class="label anonymous" *ngIf="ad['paymentPackage'] === '0' && ad['premium'] !== '1' && ad['vip'] === '0'">
					{{ locale.translations['ads']['ad']['n226'] }}
				</span>

				<span class="label upgrade" *ngIf="ad['paymentPackage'] === '3' && ad['paymentStatus'] === '0' && ad['premium'] !== '1' && ad['vip'] === '0'">
					{{ locale.translations['ads']['ad']['n659'] }}
				</span>
			</a>

			<a class="cover" (click)="onCarouselClick(ad, $event)">
				<!-- <img [src]="ad['image']" [ngStyle]="{ 'opacity': ad['sold'] === '1' ? '0.5' : null }"> -->
				<div>
					<ngb-carousel
						#carousel="ngbCarousel"
						[ngClass]="{ 'no-indicators': ad['images'].length == 1 }"
						[dir]="locale.lang == 'en' ? 'ltr' : 'rtl'"
						*ngIf="ad['images']"
						[interval]="false"
					>
						<ng-template ngbSlide *ngFor="let image of ad['images']; let i = index" id="{{ i }}">
							<div class="cover" style="cursor: pointer">
								<img [src]="image['name']" [ngStyle]="{ opacity: ad['sold'] === '1' ? '0.5' : null }" />
							</div>
						</ng-template>
					</ngb-carousel>
				</div>
			</a>

			<!-- my ads -->
			<ng-container *ngIf="isMe; else isNotMyAds">
				<a [routerLink]="['/ad/' + ad['id']]" (click)="onAdClick()">
					<div class="primary-color mt-3 title font-weight-semi-bold mx-3">&#36; {{ numbers.format(ad['price']) }}</div>

					<div class="footer fw-500 my-ad-desc mt-3 mx-3">
						<div class="line-normal">
							{{ ad['title'] }}
						</div>

						<div class="line-normal fw-400 user-ads-description my-2 fs-11px fg-grey">
							{{ ad['description'] }}
						</div>

						<div class="line-normal fw-400 fg-grey fs-11px mt-0 mb-3">{{ ad['location'] }} &bull; {{ time.fromNow(ad['createdDate']) }}</div>
						<div
							class="line-normal fw-400 fg-grey mt-0 mb-3"
							*ngIf="ad['vip'] === '1' && ad['paymentStatus'] === '1'"
							[ngClass]="{ red: ad['daysLeft'] <= 5 && ad['daysLeft'] > 0 }"
						>
							<mat-icon class="fs-18px mt-1">access_time</mat-icon>
							<span class="fs-14px" *ngIf="!ad['isExpired'] && ad['daysLeft'] > 0">
								{{ locale.translations['user']['user-ads']['n676'] }} {{ ad['daysLeft'] }} days
							</span>
							<span class="fs-14px" *ngIf="ad['isExpired'] && ad['daysLeft'] <= 0">
								{{ locale.translations['user']['user-ads']['n675'] }} {{ ad['expired_date'] }}
							</span>
						</div>
					</div>
				</a>

				<div class="actions px-3">
					<div *ngIf="!watchlist" id="n84">
						<button
							mat-button
							class="preserve px-0"
							[color]="ad['vip'] === '1' ? 'accent' : 'primary'"
							[routerLink]="['/ad/' + ad['id'] + '/edit']"
							[disabled]="ad['sold'] === '1'"
						>
							<mat-icon>create</mat-icon>
							<span>{{ locale.translations['user']['user-ads']['n84'] }}</span>
						</button>
					</div>

					<div *ngIf="!watchlist" id="n85">
						<button
							mat-button
							type="button"
							color="warn"
							class="px-0"
							(click)="onDelete(ad['id'])"
							[disabled]="ad['paymentStatus'] === '0' || ad['sold'] === '1'"
						>
							<mat-icon>delete</mat-icon>

							<span>{{ locale.translations['user']['user-ads']['n85'] }}</span>
						</button>
					</div>

					<div *ngIf="!watchlist && (ad['vip'] === '1' || ad['vipPlus'] === '1')" id="n307">
						<button
							mat-button
							type="button"
							class="px-0"
							color="primary"
							(click)="openAnalytics(ad['id'], ad['vip'], ad['vipPlus'])"
							[disabled]="ad['sold'] === '1'"
						>
							<mat-icon>analytics</mat-icon>

							<span>{{ locale.translations['ads']['ad']['n307'] }}</span>
						</button>
					</div>

					<div *ngIf="!watchlist && ad['vip'] !== '1' && ad['vipPlus'] !== '1'" id="n307">
						<button
							mat-button
							type="button"
							class="disabled_button px-0"
							(click)="openAnalytics(ad['id'], ad['vip'], ad['vipPlus'])"
							[disabled]="ad['sold'] === '1'"
						>
							<mat-icon>analytics</mat-icon>

							<span>{{ locale.translations['ads']['ad']['n307'] }}</span>
						</button>
					</div>

					<div
						class="actions_upgrade mb-12px"
						*ngIf="ad['sold'] !== '1' && ad['subCatID'] !== 0 && !watchlist"
						[ngClass]="{ 'mt-5': ad['catID'] === '' }"
					>
						<!-- boost your ad button -->
						<div
							class="boostBtn mt-12px"
							*ngIf="
								ad['vipPlus'] === '0' &&
								ad['isExpired'] !== 1 &&
								(ad['paymentPackage'] === '0' || (ad['paymentPackage'] !== '0' && ad['paymentStatus'] === '1'))
							"
							id="n95"
						>
							<div class="grey-box mx-0 fg-grey mb-2" *ngIf="ad['vip'] !== '1' && ad['vipPlus'] !== '1'">
								<mat-icon class="align-items-center d-flex fs-16px" [ngClass]="{ 'ms-2': locale.lang !== 'en', 'me-2': locale.lang === 'en' }">
									info
								</mat-icon>
								<p class="fs-13px mb-0">{{ locale.translations['user']['user-ads']['n678'] }}</p>
							</div>

							<app-button
								class="mt-2 text-center"
								(click)="onHandleClick(ad)"
								[label]="locale.translations['ads']['ad']['n448']"
								customClass="w-100 h-100 fw-400"
								svgIcon="rocket"
								[disableRipple]="true"
							></app-button>
							<!-- <mat-divider></mat-divider> -->
						</div>

						<!-- missed call ad button when ad is not basic -->
						<div
							*ngIf="
								ad['vip'] === '0' && ad['vipPlus'] === '0' && ad['missedCallsCount'] > 0 && ad['isExpired'] === 0 && ad['paymentStatus'] !== '0'
							"
							class="mt-12px"
							id="n95"
						>
							<div class="box mb-2">
								<p class="fs-14px p-12px mb-0 red">
									{{ locale.translations['ads']['ad']['n641'] }}
								</p>
							</div>

							<button
								mat-flat-button
								mat-button
								color="primary"
								class="text-center fw-400 fs-14px v2"
								[ngClass]="{ v3: locale.lang === 'ku' }"
								[routerLink]="['/missed-calls']"
								[queryParams]="{ adID: ad['id'], catID: ad['catID'] }"
							>
								<img [src]="'assets/icons/phone-missed.svg' | s3Image" class="img-responsive" [class.rtl]="locale.lang === 'ku' || locale.lang === 'ar'" />
								<span>{{ locale.translations['ads']['ad']['n642'] }}</span>
								<span class="missed-call-bg">{{ ad['missedCallsCount'] }}</span>
							</button>
						</div>

						<!-- expired ad -->
						<div *ngIf="ad['isExpired'] === 1 && ad['paymentStatus'] === '1'" class="mt-12px" id="n95">
							<div class="box mb-2">
								<p class="fs-14px p-12px mb-0 red">
									{{ locale.translations['ads']['ad']['n657'] }}
								</p>
							</div>
							<app-button
								class="text-center"
								[label]="locale.translations['payment']['n342']"
								customClass="w-100 h-100 fw-400"
								[disableRipple]="true"
								(click)="onHandleClick(ad)"
							></app-button>
						</div>

						<!-- missed call  button when ad is basic -->
						<div
							*ngIf="(ad['vip'] === '1' && ad['missedCallsCount'] > 0) || (ad['vipPlus'] === '1' && ad['missedCallsCount'] > 0)"
							class="mt-12px"
							id="n95"
						>
							<button
								mat-stroked-button
								mat-button
								color="primary"
								class="text-center fw-400 fs-14px v2 mb-12px"
								[routerLink]="['/missed-calls']"
								[queryParams]="{ adID: ad['id'], catID: ad['catID'] }"
							>
								<mat-icon class="fs-18px phone-missed-icon mat-icon-rtl-mirror">phone_missed</mat-icon>

								<span>{{ locale.translations['ads']['ad']['n643'] }}</span>
							</button>
						</div>

						<!-- vip ad active status details -->
						<div
							*ngIf="ad['vip'] === '1' && ad['vipAd']['remaningDaysForVIP'] >= 0"
							class="d-flex flex-row justify-content-between vip-ad mt-12px"
							[ngClass]="{ 'border-success': locale.lang === 'en', 'border-sucess-right': locale.lang !== 'en' }"
						>
							<div class="detail-1 col-9">
								<div class="fg-grey">{{ locale.translations['ads']['ad']['n450'] | titlecase }}</div>
								<div>
									{{ locale.translations['ads']['ad']['n452'] }}&nbsp;{{ time.fromNow(ad['vipAd']['vipDate']) }}&nbsp;{{
										locale.translations['ads']['ad']['n451']
									}}
									{{ getExpiryDate(ad['vipAd']['vipDate']) }}
								</div>
							</div>

							<div class="detail-2 col-3 alignment-change">
								<span>{{ locale.translations['ads']['ad']['n453'] }}</span>
							</div>
						</div>

						<!-- vipPlus ad active status details -->
						<div
							*ngIf="ad['vipPlus'] === '1'"
							class="d-flex flex-row justify-content-between vip-ad mt-12px"
							[ngClass]="{ 'border-success': locale.lang === 'en', 'border-sucess-right': locale.lang !== 'en' }"
						>
							<div class="detail-1 col-9">
								<div class="fg-grey">{{ locale.translations['ads']['ad']['n450'] | titlecase }}</div>
								<div>{{ locale.translations['n725'] }}</div>
							</div>

							<div class="detail-2 col-3 alignment-change">
								<span>{{ locale.translations['ads']['ad']['n453'] }}</span>
							</div>
						</div>
					</div>

					<div *ngIf="!watchlist && ad['sold'] === '1'" class="sold-delete">
						<mat-icon>alarm</mat-icon>

						<span>{{ locale.translations['user']['user-ads']['n112'] }} {{ time.fromNow(ad['soldDate'], true) }}</span>
					</div>

					<button mat-button type="button" color="warn" (click)="onUnWatch(i)" id="n86" *ngIf="watchlist" class="text-center w-100">
						<mat-icon class="mt-0">favorite_border</mat-icon>

						<span>{{ locale.translations['user']['user-ads']['n86'] }}</span>
					</button>
				</div>
			</ng-container>

			<!-- other's ads -->
			<ng-template #isNotMyAds>
				<a [routerLink]="['/ad/' + ad['id']]" (click)="onAdClick()">
					<div class="primary-color mt-3 title font-weight-semi-bold mx-3">&#36; {{ numbers.format(ad['price']) }}</div>

					<div class="footer fw-500 my-ad-desc mt-3 mx-3">
						{{ ad['title'] }}

						<div class="fw-400 fg-grey fs-11px mt-0 my-3">{{ ad['location'] }} &bull; {{ time.fromNow(ad['createdDate']) }}</div>
					</div>
				</a>

				<mat-divider *ngIf="viewport.type !== 'desktop' && i !== ads.length - 1"></mat-divider>
			</ng-template>
		</div>
	</ng-container>

	<div class="pagination mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone" *ngIf="pages >= 2">
		<div>
			<button
				[dir]="locale.lang === 'en' ? 'ltr' : 'rtl'"
				mat-button
				(click)="onPreviousPage()"
				[disabled]="page === 1"
				[matTooltipDisabled]="page === 1"
				matTooltip="{{ locale.translations['ads']['n21'] }}"
				matTooltipPosition="after"
				id="n21"
			>
				<mat-icon class="mat-icon-rtl-mirror">keyboard_arrow_left</mat-icon>
			</button>
		</div>

		<div class="w-100">
			<ul>
				<!-- first page -->
				<li *ngIf="page > 5 && viewport.type === 'desktop'">
					<button mat-button (click)="onPage(1)">1</button>
				</li>

				<li *ngIf="page > 5 && viewport.type === 'desktop'">...</li>

				<!-- previous pages -->
				<li *ngIf="page >= 5 && viewport.type === 'desktop'">
					<button mat-button (click)="onPage(page - 4)">{{ page - 4 }}</button>
				</li>

				<li *ngIf="page >= 4 && viewport.type === 'desktop'">
					<button mat-button (click)="onPage(page - 3)">{{ page - 3 }}</button>
				</li>

				<li *ngIf="page >= 3">
					<button mat-button (click)="onPage(page - 2)">{{ page - 2 }}</button>
				</li>

				<li *ngIf="page >= 2">
					<button mat-button (click)="onPage(page - 1)">{{ page - 1 }}</button>
				</li>

				<!-- current page -->
				<li>
					<button mat-button color="primary">{{ page }}</button>
				</li>

				<!-- next pages -->
				<li *ngIf="page + 1 <= pages">
					<button mat-button (click)="onPage(page + 1)">{{ page + 1 }}</button>
				</li>

				<li *ngIf="page + 2 <= pages">
					<button mat-button (click)="onPage(page + 2)">{{ page + 2 }}</button>
				</li>

				<li *ngIf="page + 3 <= pages && viewport.type === 'desktop'">
					<button mat-button (click)="onPage(page + 3)">{{ page + 3 }}</button>
				</li>

				<li *ngIf="page + 4 <= pages && viewport.type === 'desktop'">
					<button mat-button (click)="onPage(page + 4)">{{ page + 4 }}</button>
				</li>

				<!-- last page -->
				<li *ngIf="page + 5 <= pages && viewport.type === 'desktop'">...</li>

				<li *ngIf="page + 5 <= pages && viewport.type === 'desktop'">
					<button mat-button (click)="viewport.type !== 'desktop' ? onPage(page + 5) : onPage(pages)">
						{{ viewport.type !== 'desktop' ? page + 5 : pages }}
					</button>
				</li>
			</ul>
		</div>

		<div>
			<button
				[dir]="locale.lang === 'en' ? 'ltr' : 'rtl'"
				mat-button
				(click)="onNextPage()"
				[disabled]="page === pages"
				[matTooltipDisabled]="page === pages"
				matTooltip="{{ locale.translations['ads']['n22'] }}"
				matTooltipPosition="before"
				id="n22"
			>
				<mat-icon class="mat-icon-rtl-mirror">keyboard_arrow_right</mat-icon>
			</button>
		</div>
	</div>
</div>

<mat-menu #adsFilter="matMenu" class="ad-filter-menu" xPosition="before">
	<button mat-menu-item class="border-bottom" (click)="selectAdFilter('All Ads')">
		<span>{{ locale.translations['dealer']['n351'] | titlecase }}</span>
	</button>
	<button mat-menu-item class="border-bottom" (click)="selectAdFilter('Free Ads')">
		<span>{{ locale.translations['user']['user-ads']['filter']['n669'] }}</span>
	</button>
	<button mat-menu-item class="border-bottom" (click)="selectAdFilter('VIP Ads')">
		<span>{{ locale.translations['user']['user-ads']['filter']['n671'] }}</span>
	</button>
	<button mat-menu-item class="border-bottom" (click)="selectAdFilter('VIP+ Ads')">
		<span>{{ locale.translations['n710'] }}</span>
	</button>
	<button mat-menu-item class="border-bottom" (click)="selectAdFilter('Expired Ads')">
		<span>{{ locale.translations['user']['user-ads']['filter']['n672'] }}</span>
	</button>
	<button mat-menu-item (click)="selectAdFilter('Pending Ads')">
		<span>{{ locale.translations['user']['user-ads']['filter']['n673'] }}</span>
	</button>
</mat-menu>
